/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleClassNameFactory = function (cssModuleName) { return function (addon) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    return [addon ? cssModuleName + "-" + addon : cssModuleName].concat(rest).join(" ");
}; };